import { Button } from 'semantic-ui-react'

import styles from './Error.module.css'

export default function HomeButton({ background }) {
	return (
		<a href="/">
			<Button content="Home" className={styles.errorHomeButton} style={{ background }} />
		</a>
	)
}
